import { indexOf } from "lodash-es";
import Blue from "~/core";

new Blue({
	name: 'Practice Filter',
	selector: ".practice-filter",
	setup(container) {
		// BEGIN ACCORDION CODE
		const accordion = container.querySelector(".practice-filter__accordion");
    const firstChildSubItems = [...accordion.querySelectorAll('.practice-filter__accordion-sub-item:first-of-type')];
		let items = firstChildSubItems.map(_i => _i.closest(".practice-filter__accordion-item"));
		const expandLink = container.querySelector("a.practice-filter__expand-all-trigger");
		let toggles = [];
		let allExpanded = false;
		
    items.forEach(container => {
			let trigger = container.querySelector('button.practice-filter__accordion-trigger')
      let content = container.querySelector('.practice-filter__accordion-content')
      let config = {
				container,
        trigger,
        content,
      }
      toggles.push(new this.$toggle(config));

			this.$addEvents(trigger, "click.prevent", () => {
				if (items.every(i => i.matches("[data-active]"))) {
					allExpanded = true;
					expandLink.textContent = "Collapse All";
				} else if (items.every(i => !i.matches("[data-active]"))) {
					allExpanded = false;
					expandLink.textContent = "Expand All";
				}
			});
    });
		
		this.$addEvents(expandLink, "click.prevent", () => {
			if (!allExpanded) {
				toggles.forEach((t, i) => {
					if (!items[i].matches("[data-active]")) t.toggle();
				});
				expandLink.textContent = "Collapse All";
			} else {
				toggles.forEach(t => t.close());
				expandLink.textContent = "Expand All";
			}
			allExpanded = !allExpanded;
		});
		// END ACCORDION CODE
		// ##################

		// #################################
		// BEGIN SEARCH FILTER/DROPDOWN CODE
		const form = container.querySelector(".practice-filter__search-form");
		const input = container.querySelector("input.practice-filter__search-input");
		const dropdown = container.querySelector(".practice-filter__search-dropdown");
		const links = [...accordion.querySelectorAll("a.practice-filter__accordion-link, a.practice-filter__accordion-sub-link")];
		const itemSlug = dropdown.querySelector("a.practice-filter__search-item--slug");
		
		const filterLinks = str => {
			return links.filter(link => {
				return link.textContent.toLowerCase().includes(str.toLowerCase()) || link.href.toLowerCase().includes(str.toLowerCase());
			});
		}

		const generateDropdownItems = results => {
			let currentItems = [...dropdown.querySelectorAll(".practice-filter__search-item:not(.practice-filter__search-item--slug)")];
			currentItems.forEach(i => i.remove());
			results.forEach(link => {
				let isUniqueLink = [...dropdown.querySelectorAll(".practice-filter__search-item:not(.practice-filter__search-item--slug)")]
					.every(_link => _link.textContent !== link.textContent);
				if (isUniqueLink) {
					let newItem = itemSlug.cloneNode();
					newItem.setAttribute("href", link.href);
					newItem.textContent = link.textContent;
					newItem.classList.remove("practice-filter__search-item--slug");
					dropdown.insertAdjacentElement("beforeend", newItem);
				}
			});
			const newItemArray = [...dropdown.querySelectorAll("a.practice-filter__search-item:not(.practice-filter__search-item--slug)")];
			newItemArray.forEach((item, index) => {
				this.$addEvents(item, "down", e => {
					e.preventDefault();
					if (index + 1 == newItemArray.length) input.focus();
					else  {
						let nextItem = newItemArray[index + 1];
						nextItem.focus()
					}
				});
				this.$addEvents(item, "up", e => {
					e.preventDefault();
					if (index == 0) input.focus();
					else  {
						let prevItem = newItemArray[index - 1];
						prevItem.focus()
					}
				});
			});
		}

		this.$addEvents(input, "input", () => {
			let val = input.value;
			if (val.trim() == '') {
				form.classList.remove("has-results");
				return;
			}
			generateDropdownItems(filterLinks(val));
			if (filterLinks(val).length > 0) form.classList.add("has-results");
			else form.classList.remove("has-results");
		});

		this.$addEvents(input, "down", e => {
			if (!form.matches(".has-results")) return;
			e.preventDefault();
			let firstItem = dropdown.querySelector("a.practice-filter__search-item:not(.practice-filter__search-item--slug)");
			firstItem.focus()
		});
		// END SEARCH FILTER/DROPDOWN CODE
	}
});